import { getApi } from './Api';

export interface LedgerMapping {
  id: string;
  entityId: string;
  entityType: string;
  accountingLedgerId: string;
  accountingLedgerType: string;
  deleted: boolean;
  metadata: Record<string, any>;
  eventDate?: string;
  accountingLedgerHumanId?: string | null;
}

export interface CreateLedgerMappingCommand {
  entityId: string;
  entityType: string;
  accountingLedgerHumanId: string;
}

export interface UpdateLedgerMappingCommand {
  id: string;
  entityId: string;
  entityType: string;
  accountingLedgerHumanId: string;
}

export interface PaginatedResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}

async function listMappings(
  entityType: string,
  entityId: string,
  page = 0,
  size = 20
): Promise<PaginatedResponse<LedgerMapping>> {
  const api = getApi();
  const { data } = await api.get<PaginatedResponse<LedgerMapping>>('/v3/accounting-binds', {
    params: { entityType, entityId, page, size },
  });
  return data;
}

async function createMapping(command: CreateLedgerMappingCommand): Promise<LedgerMapping> {
  const api = getApi();
  const { data } = await api.post<LedgerMapping>('/v3/accounting-binds', command);
  return data;
}

async function updateMapping(command: UpdateLedgerMappingCommand): Promise<LedgerMapping> {
  const api = getApi();
  const { data } = await api.put<LedgerMapping>(`/v3/accounting-binds/${command.id}`, command);
  return data;
}

async function deleteMapping(id: string): Promise<void> {
  const api = getApi();
  await api.delete(`/v3/accounting-binds/${id}`);
}

async function getCustomerLedgerMapping(customerId: string): Promise<LedgerMapping | null> {
  try {
    const response = await listMappings('customer', customerId, 0, 1);
    return response.content.length > 0 ? response.content[0] : null;
  } catch (error) {
    console.error('Error fetching customer ledger mapping:', error);
    return null;
  }
}

export default {
  listMappings,
  createMapping,
  updateMapping,
  deleteMapping,
  getCustomerLedgerMapping,
};
